import React from "react";
import { Box, Stack } from "@mui/material";
import { PhysicalOnePagerResultStyle } from "../PhysicalOnePagerResultStyle";
import VSNTypography from "../../../../shared/VSNTypography";
import {
  yearOnYearoptionLegends1,
  yearOnYearoptionLegends2,
} from "./AssessmentConstant";
import {
  MetricChart,
  MetricTable,
  YearOnYearOptionChart,
} from "../../../assessment/CPETChartCommonComponent";

const YearOnYearComparison = ({ data }) => {
  const classes = PhysicalOnePagerResultStyle();

  return (
    <Box>
      <Stack className={classes.assessmentReportCard} gap={4}>
        <VSNTypography fontWeight={700}>
          {data?.description ?? ""}
        </VSNTypography>
        <Box
          sx={{ backgroundColor: "#FFFFFF" }}
          padding={{ sm: 3, xs: 2 }}
          borderRadius="10px"
        >
          <Stack gap={3}>
            <VSNTypography
              variant="h5"
              fontSize={{ sm: 24, xs: 18 }}
              fontWeight={700}
            >
              {data?.chart_title ?? ""}
            </VSNTypography>
            <Stack
              direction={{ md: "row", xs: "column" }}
              gap={{ sm: 2, xs: 2 }}
              mb={2}
            >
              <Stack direction="row" gap={2} flexWrap="wrap">
                {yearOnYearoptionLegends1?.map((item, index) => (
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    gap={1}
                    key={index}
                  >
                    {item?.color && (
                      <Stack height="auto" width="auto" justifyContent="center">
                        <Box
                          sx={{
                            backgroundColor: item?.color,
                            width: 16,
                            height: 16,
                            borderRadius: "4px",
                          }}
                        />
                      </Stack>
                    )}
                    <VSNTypography fontSize={{ sm: 18, xs: 14 }}>
                      {item?.label}
                    </VSNTypography>
                  </Stack>
                ))}
              </Stack>
              <Stack direction="row" gap={{ sm: 2, xs: 1 }} flexWrap="wrap">
                {yearOnYearoptionLegends2?.map((item, index) => (
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing="8px"
                    key={index}
                  >
                    {item?.color && (
                      <Stack height="auto" width="auto" justifyContent="center">
                        <Box
                          sx={{
                            backgroundColor: item?.color,
                            width: 16,
                            height: 16,
                            borderRadius: "4px",
                          }}
                        />
                      </Stack>
                    )}
                    <VSNTypography>{item?.label}</VSNTypography>
                  </Stack>
                ))}
              </Stack>
            </Stack>
          </Stack>

          <Stack direction={{ md: "row", xs: "column" }}>
            <YearOnYearOptionChart
              data={data?.chart_data?.comparison_to_previous_1}
              height="380px"
            />
            <YearOnYearOptionChart
              data={data?.chart_data?.comparison_to_previous_2}
              height="380px"
            />
          </Stack>
        </Box>

        <Box textAlign="center">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
          >
            {data?.bar_values?.map((data, index) => (
              <MetricChart
                key={index}
                metric={data.title}
                currentValue={data.current}
                pastValue={data.past}
                unit={data.unit}
                percentage={data?.percentage}
              />
            ))}
          </Stack>
          <Box
            mt={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Box display="flex" alignItems="center" mx={1}>
              <Box width={12} height={12} bgcolor="#809dff" mr={1} />
              <VSNTypography variant="body2">Past</VSNTypography>
            </Box>
            <Box display="flex" alignItems="center" mx={1}>
              <Box width={12} height={12} bgcolor="#3b4a9f" mr={1} />
              <VSNTypography variant="body2">Current</VSNTypography>
            </Box>
          </Box>
        </Box>

        <Box display={{ sm: "block", md: "flex" }} gap={2}>
          {data?.table?.map((rows, key) => {
            return <MetricTable key={key} rows={rows} />;
          })}
        </Box>
      </Stack>
    </Box>
  );
};

export default YearOnYearComparison;
